import { createContext } from 'react';

export const ProjectContext = createContext({ returnPath: null });



// WEBPACK FOOTER //
// ./src/components/projects/ProjectContext.js